import {updateURL} from "./utils";

$(function () {
    let currentFilter = getUrlParamsFromCookies();

    function setSelectedValue(selectElement, value) {
        if (value) {
            selectElement.val(value).trigger('change');
        }
    }

    function populateSelectWithFetch(url, selectElement, defaultText, selectedValue, callback) {
        fetch(url)
            .then(response => response.json())
            .then(data => {
                // selectElement.empty().append(new Option(defaultText, defaultText));

                const dataLabel = selectElement.attr('data-label');
                selectElement.find('option').not(`:contains(${defaultText})`).remove();

                data.forEach(datum => {
                    if (!selectElement.find(`option[value='${datum}']`).length) {
                        const option = new Option(datum, datum);
                        selectElement.append(option);
                    }
                });

                selectElement.attr('data-label', dataLabel);

                setSelectedValue(selectElement, selectedValue);

                if (callback) {
                    callback();
                }
            });
    }

    function getUrlParamsFromCookies() {
        return {
            brand: window.shop.ReadCookie('filterBrand') || '',
            model: window.shop.ReadCookie('filterModel') || '',
            year: window.shop.ReadCookie('filterYear') || '',
            inStock: window.shop.ReadCookie('filterInStock') || ''
        };
    }

    function updateFiltersInCookies() {
        window.shop.WriteCookie('filterBrand', currentFilter.brand, 7);
        window.shop.WriteCookie('filterModel', currentFilter.model, 7);
        window.shop.WriteCookie('filterYear', currentFilter.year, 7);
        window.shop.WriteCookie('filterInStock', currentFilter.inStock, 7);
    }

    function resetFilters() {
        window.shop.WriteCookie('filterBrand', '', -1);
        window.shop.WriteCookie('filterModel', '', -1);
        window.shop.WriteCookie('filterYear', '', -1);
        window.shop.WriteCookie('filterInStock', '', -1);
        location.reload(); // Reload to apply the reset filters
    }

    if (currentFilter.brand) {
        populateSelectWithFetch("/filter/brands", $('.bike-model'), 'Не выбрана', currentFilter.brand);
    } else {
        populateSelectWithFetch("/filter/brands", $('.bike-model'), 'Не выбрана', '');
    }

    if (currentFilter.model) {
        fetch(`/filter/brand/${currentFilter.brand}/`)
            .then(response => response.json())
            .then(data => {
                const bikeOptionSelect = $('.bike-option');
                bikeOptionSelect.empty().append(new Option('Не выбрана', ''));

                data.forEach(datum => {
                    const option = new Option(datum, datum);
                    bikeOptionSelect.append(option);
                });
                setSelectedValue(bikeOptionSelect, currentFilter.model);
            });
    }

    if (currentFilter.year) {
        fetch(`/filter/brand/${currentFilter.brand}/${currentFilter.model}/years`)
            .then(response => response.json())
            .then(data => {
                const bikeYearSelect = $('.bike-year');
                bikeYearSelect.empty().append(new Option('Не выбран', ''));

                data.forEach(datum => {
                    const option = new Option(datum, datum);
                    bikeYearSelect.append(option);
                });
                setSelectedValue(bikeYearSelect, currentFilter.year);
            });
    }

    $('.bike-model').on('change', function () {
        let selectedBrand = $(this).val();
        if (selectedBrand && currentFilter.brand !== selectedBrand) {
            currentFilter.brand = selectedBrand;
            currentFilter.model = '';
            currentFilter.year = '';
            updateFiltersInCookies();
            populateSelectWithFetch(`/filter/brand/${selectedBrand}/`, $('.bike-option'), 'Не выбрана', '');
        }
    });

    $('.bike-option').on('change', function () {
        let selectedBrand = $('.bike-model:visible').val();
        let selectedModel = $(this).val();
        if (selectedModel && currentFilter.model !== selectedModel) {
            currentFilter.model = selectedModel;
            currentFilter.year = '';
            updateFiltersInCookies();
            populateSelectWithFetch(`/filter/brand/${selectedBrand}/${selectedModel}/years`, $('.bike-year'), 'Не выбран', '');
        }
    });

    $('.bike-year').on('change', function () {
        let selectedBrand = $('.bike-model:visible').val();
        let selectedModel = $('.bike-option:visible').val();
        let selectedYear = $(this).val();
        if (selectedYear && currentFilter.year !== selectedYear) {
            currentFilter.year = selectedYear;
            updateFiltersInCookies();
        }
    });

    $('.reset-filters').on('click', function () {
        updateURL({brand: null, model: null, year: null}, false);
        resetFilters();
    });

    $('.apply-filters').on('click', function () {
        let selectedBrand = $('.bike-model:visible').val();
        let selectedModel = $('.bike-option:visible').val();
        let selectedYear = $('.bike-year:visible').val();

        let filter = {};
        if (selectedBrand !== 'Не выбрана') {
            filter.brand = selectedBrand;
        }

        if (selectedModel !== 'Не выбрана') {
            filter.model = selectedModel;
        }

        if (selectedYear !== 'Не выбран') {
            filter.year = selectedYear;
        }

        updateURL(filter, true);
    });

    $('.header__logo').on('click', function () {

        resetFilters();
        window.location.href = '/';
    });

    $(".b-catalog__instock > input[type=checkbox]").on("change", function () {
        let isChecked = $(this).is(":checked");
        currentFilter.inStock = isChecked ? "true" : "";
        updateFiltersInCookies();

        // Update URL and reload page with new filter
        let filter = {
            brand: currentFilter.brand,
            model: currentFilter.model,
            year: currentFilter.year,
            inStock: currentFilter.inStock
        };
        updateURL(filter, true);
    });

    // Initialize filters on page load
    $(document).ready(function () {
        let inStockCheckbox = $(".b-catalog__instock > input[type=checkbox]");
        inStockCheckbox.prop('checked', currentFilter.inStock === 'true');
        
        populateSelectWithFetch("/filter/brands", $('.bike-model'), 'Не выбрана', currentFilter.brand, function () {
            if (currentFilter.brand && currentFilter.brand !== 'Не выбрана') {
                populateSelectWithFetch(`/filter/brand/${currentFilter.brand}/`, $('.bike-option'), 'Не выбрана', currentFilter.model, function () {
                    if (currentFilter.model && currentFilter.model !== 'Не выбрана') {
                        populateSelectWithFetch(`/filter/brand/${currentFilter.brand}/${currentFilter.model}/years`, $('.bike-year'), 'Не выбран', currentFilter.year);
                    }
                });
            }
        });
    });
});
